import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';
import Progress from 'screens/BrokerPortal/screens/Registration/components/Progress/Progress';

export default connect((state: RootState) => {
  return {
    currentStep: state.registration.currentStep || 0,
  };
}, {})(Progress);
